const lessonPlans = {
  pageTitle: 'خطة الدرس',
  pageSubtitle: 'تصميم وهيكلة خطة درس مخصصة',
  backToDashboard: 'العودة إلى لوحة التحكم',
  planSettings: 'إعدادات الخطة',
  planType: 'نوع الخطة',
  individual: 'فردي',
  group: 'جماعي',
  targetStudents: 'الطلاب المستهدفون',
  selectStudents: 'اختر الطلاب...',
  noStudentsFound: 'لم يتم العثور على طلاب',
  selectedCount: '{{count}} محدد',
  dateRange: 'نطاق التاريخ',
  startDate: 'تاريخ البداية',
  endDate: 'تاريخ النهاية',
  themeTopic: 'الموضوع / الوحدة',
  themePlaceholder: 'مثال: مساعدو المجتمع، فصل الخريف',
  themeHelper: 'يضع سياق بيئة التعلم',
  skillGoalSection: 'اختيار المهارة والهدف والغرض',
  skillDomain: 'المهارة / المجال',
  skillDomainDesc: 'حدد جميع المجالات التنموية الأساسية المستهدفة',
  noSkillsSelected: 'لم يتم تحديد مهارات',
  goalsAndTargets: 'الأهداف والغايات',
  longTermGoal: 'الهدف طويل المدى',
  longTermGoalPlaceholder: 'مثال: سيدير الطالب روتين النظافة الشخصية بشكل مستقل بنهاية الفصل الدراسي.',
  shortTermObjective: 'الهدف قصير المدى',
  shortTermObjectivePlaceholder: 'مثال: سيغسل الطالب يديه بتوجيهات لفظية فقط، 4 من 5 مرات.',
  learningProfiles: 'ملفات التعلم والموارد',
  learningStylesTargeted: 'أساليب التعلم المستهدفة',
  learningStylesDesc: 'اختر الأساليب التي تدعم الطالب/الطلاب بشكل أفضل',
  noStylesSelected: 'لم يتم تحديد أساليب تعلم',
  tlmMaterials: 'مواد التعليم والتعلم (TLM)',
  tlmDesc: 'اختر المواد القياسية وأضف عناصر مخصصة',
  standardMaterials: 'المواد القياسية',
  customMaterials: 'المواد المخصصة',
  addCustomMaterial: 'اكتب واضغط Enter للإضافة',
  noMaterialsSelected: 'لم يتم تحديد مواد',
  procedureSection: 'الإجراء متعدد الخطوات',
  procedureDesc: 'تقسيم المهام إلى خطوات دقيقة (تحليل المهام)',
  addStep: 'إضافة خطوة',
  removeStep: 'إزالة الخطوة',
  stepNumber: 'الخطوة {{number}}',
  stepTitle: 'عنوان الخطوة',
  stepTitlePlaceholder: 'مثال: الإحماء / التركيز',
  educatorAction: 'إجراء المعلم',
  educatorActionPlaceholder: 'ما يقوله أو يفعله المعلم...',
  studentExpectation: 'توقع الطالب',
  studentExpectationPlaceholder: 'كيف يجب أن يستجيب الطالب...',
  promptHierarchy: 'مستوى التسلسل الهرمي للتوجيه',
  noProcedureSteps: 'لم تتم إضافة خطوات إجراء بعد. انقر على "إضافة خطوة" للبدء.',
  evaluationSection: 'التقييم والمتابعة',
  evaluationDesc: 'تتبع سلوكيات أو معالم محددة متعددة ضمن هذا الدرس',
  addMetric: 'إضافة مقياس',
  removeMetric: 'إزالة المقياس',
  metricNumber: 'المقياس {{number}}',
  targetBehavior: 'السلوك المستهدف',
  targetBehaviorPlaceholder: 'مثال: التواصل البصري، الفرز الصحيح',
  measurementCriteria: 'معايير القياس',
  successThreshold: 'عتبة النجاح',
  successThresholdPlaceholder: 'مثال: دقة 80% على مدى 3 أيام متتالية',
  noEvaluationMetrics: 'لم تتم إضافة مقاييس تقييم بعد. انقر على "إضافة مقياس" للبدء.',
  continuitySection: 'الاستمرارية والمراجعة النهائية',
  followUpPlan: 'خطة المتابعة',
  followUpPlanPlaceholder: 'استراتيجيات التعميم عبر الإعدادات، أنشطة التعزيز المنزلي، أو الخطوات التربوية المنطقية التالية...',
  finalEvaluation: 'التقييم النهائي / ملاحظات الجلسة',
  finalEvaluationDesc: 'يتم ملؤها بعد إجراء الدرس',
  finalEvaluationPlaceholder: 'التقط ما نجح، والمحفزات الحسية غير المتوقعة، وملاحظات المشاركة العامة...',
  saveDraft: 'حفظ كمسودة',
  submitPlan: 'تقديم خطة الدرس',
  planSavedDraft: 'تم حفظ خطة الدرس كمسودة!',
  planSubmitted: 'تم تقديم خطة الدرس بنجاح!',
  validationSelectStudents: 'يرجى اختيار طالب واحد على الأقل',
  validationDateRange: 'يرجى اختيار تاريخي البداية والنهاية',
  validationTheme: 'الموضوع / الوحدة مطلوب',
  validationSkillDomain: 'يرجى اختيار مجال مهارة واحد على الأقل',
  validationLongTermGoal: 'الهدف طويل المدى مطلوب',
  validationShortTermObjective: 'الهدف قصير المدى مطلوب',
  validationLearningStyles: 'يرجى اختيار أسلوب تعلم واحد على الأقل',
  validationProcedureSteps: 'يرجى إضافة خطوة إجراء واحدة على الأقل',
  listPageTitle: 'خطط الدروس الخاصة بي',
  listPageSubtitle: 'عرض وإدارة وتتبع جميع خطط الدروس الخاصة بك',
  newPlan: 'خطة درس جديدة',
  saveAsTemplate: 'حفظ كقالب',
  saveAsTemplateTitle: 'حفظ كقالب',
  templateName: 'اسم القالب',
  templateNamePlaceholder: 'مثال: خطة الروتين الصباحي',
  templateSaved: 'تم حفظ القالب بنجاح!',
  planTypeIndividual: 'فردي',
  planTypeGroup: 'جماعي',
  statusSubmitted: 'مُقدم',
  statusInProgress: 'قيد التنفيذ',
  statusCompleted: 'مكتمل',
  noLessonPlans: 'لا توجد خطط دروس حتى الآن',
  noLessonPlansDesc: 'أنشئ خطتك الدراسية الأولى للبدء.',
  noTemplates: 'لم يتم حفظ أي قوالب بعد',
  noTemplatesDesc: 'احفظ خطة درس كقالب لإعادة استخدامها لاحقًا.',
  searchPlans: 'البحث في خطط الدروس...',
  filterByStatus: 'تصفية حسب الحالة',
  allPlans: 'جميع الخطط',
  myTemplates: 'قوالبي',
  duplicatePlan: 'نسخ',
  deletePlan: 'حذف الخطة',
  deletePlanConfirm: 'هل أنت متأكد من حذف خطة الدرس هذه؟',
  planDeleted: 'تم حذف خطة الدرس',
  planDuplicated: 'تم نسخ خطة الدرس',
  useTemplate: 'استخدام القالب',
  stepsCount: '{{count}} خطوات',
  metricsCount: '{{count}} مقاييس',
  skillsCount: '{{count}} مهارات',
};

export default lessonPlans;